/* STEFANO - Mix & Match Bikini v3 (TJ Swim layout)
   ----------------------------------------------------------------
   - Carosello con frecce disabilitate a inizio/fine (no loop)
   - Card centrale grande, peek laterali su tutti i breakpoint
   - Click foto/titolo carosello -> apre PDP
   - Click titolo grande pannello dettagli -> apre PDP
   - Layout: foto+caption a sx, dettagli+CTA a dx (desktop); stack su mobile
   - Add to cart con apertura cart drawer Prestige
   ---------------------------------------------------------------- */
(function () {
  'use strict';

  var SIZE_OPTION_PATTERNS = [/^taglia$/i, /^size$/i, /^misura$/i];

  document.querySelectorAll('[data-mm-bikini]').forEach(initMixMatch);

  function initMixMatch(root) {
    var dataNode = root.querySelector('[data-mm-data]');
    if (!dataNode) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (e) {
      console.warn('[mm] JSON parse error', e);
      return;
    }

    var state = {
      top: { handle: null, variantId: null, product: null, currentIndex: 0 },
      slip: { handle: null, variantId: null, product: null, currentIndex: 0 },
      feedbackTimer: null,
      // STEFANO - i18n: stringhe lette dai data attributes del container Liquid
      i18n: {
        locale:        root.getAttribute('data-mm-locale')          || 'it-IT',
        ctaSetAdd:     root.getAttribute('data-mm-msg-cta-set-add') || 'Aggiungi set al carrello',
        ctaSelect:     root.getAttribute('data-mm-msg-cta-select')  || 'Seleziona le taglie',
        msgSetAdded:   root.getAttribute('data-mm-msg-set-added')   || 'Set aggiunto al carrello.',
        msgTopAdded:   root.getAttribute('data-mm-msg-top-added')   || 'Top aggiunto al carrello.',
        msgSlipAdded:  root.getAttribute('data-mm-msg-slip-added')  || 'Slip aggiunto al carrello.',
        msgError:      root.getAttribute('data-mm-msg-error')       || 'Errore aggiunta al carrello.',
        badgeSoldOut:  root.getAttribute('data-mm-badge-soldout')   || 'Esaurito',
        linkAria:      root.getAttribute('data-mm-link-aria')       || 'Vai a'
      }
    };

    buildCarousel(root, 'top', data.tops, state);
    buildCarousel(root, 'slip', data.slips, state);

    var topInitialIdx = indexOf(data.tops, data.currentType === 'top' ? data.currentHandle : null);
    var slipInitialIdx = indexOf(data.slips, data.currentType === 'slip' ? data.currentHandle : null);

    setSelected(root, 'top', state, data.tops, topInitialIdx);
    setSelected(root, 'slip', state, data.slips, slipInitialIdx);

    bindNav(root, 'top', state, data.tops);
    bindNav(root, 'slip', state, data.slips);
    bindCardClick(root, 'top', state, data.tops);
    bindCardClick(root, 'slip', state, data.slips);
    bindSwipe(root, 'top', state, data.tops);
    bindSwipe(root, 'slip', state, data.slips);
    bindCta(root, state);
    bindCtaSingle(root, state, 'top');
    bindCtaSingle(root, state, 'slip');
  }

  // ----- helpers ------------------------------------------------

  function indexOf(list, handle) {
    if (!handle) return 0;
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) return i;
    }
    return 0;
  }

  function formatPrice(cents, locale) {
    var euros = cents / 100;
    var loc = locale || 'it-IT';
    try {
      return euros.toLocaleString(loc, { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return '€' + euros.toFixed(2).replace('.', ',');
    }
  }

  function detectSizeOptionIndex(product) {
    if (!product.optionNames || !product.optionNames.length) return 1;
    for (var i = 0; i < product.optionNames.length; i++) {
      var name = product.optionNames[i] || '';
      for (var j = 0; j < SIZE_OPTION_PATTERNS.length; j++) {
        if (SIZE_OPTION_PATTERNS[j].test(name)) return i;
      }
    }
    return product.optionNames.length >= 2 ? 1 : 0;
  }

  function getSizeValue(variant, sizeOptionIndex) {
    var key = 'option' + (sizeOptionIndex + 1);
    return variant[key] || variant.title;
  }

  // ----- carosello build ---------------------------------------

  function buildCarousel(root, type, list, state) {
    var track = root.querySelector('[data-mm-track="' + type + '"]');
    if (!track) return;
    var i18n = (state && state.i18n) || {};
    var badgeSoldOut = i18n.badgeSoldOut || 'Esaurito';
    var linkAria = i18n.linkAria || 'Vai a';
    // STEFANO - renderizzo TUTTI i prodotti in fila; lo scroll viene fatto via translateX su track
    var html = list.map(function (product, idx) {
      var soldOut = product.variants.every(function (v) { return !v.available; });
      var img = product.image
        ? '<img class="mm-card__img" src="' + escAttr(product.image) + '" alt="' + escAttr(product.title) + '" loading="lazy">'
        : '<div class="mm-card__img mm-card__img--ph"></div>';
      return (
        '<div class="mm-card' + (soldOut ? ' is-soldout' : '') + '" data-mm-card data-index="' + idx + '" data-handle="' + escAttr(product.handle) + '" data-url="' + escAttr(product.url) + '">' +
          '<a class="mm-card__link" href="' + escAttr(product.url) + '" aria-label="' + escAttr(linkAria) + ' ' + escAttr(product.title) + '">' +
            '<div class="mm-card__media">' + img +
              (soldOut ? '<span class="mm-card__badge">' + escText(badgeSoldOut) + '</span>' : '') +
            '</div>' +
          '</a>' +
        '</div>'
      );
    }).join('');
    track.innerHTML = html;
  }

  // ----- selezione prodotto ------------------------------------

  function setSelected(root, type, state, list, index) {
    if (!list.length) return;
    if (index < 0) index = 0;
    if (index >= list.length) index = list.length - 1;
    state[type].currentIndex = index;
    var product = list[index];
    state[type].handle = product.handle;
    state[type].product = product;
    state[type].variantId = null;

    // STEFANO - sposto la track impostando una CSS var: il CSS gestisce translateX e transition
    var track = root.querySelector('[data-mm-track="' + type + '"]');
    if (track) {
      track.style.setProperty('--mm-active-index', String(index));
      // marker visuale: card centrale active, le altre dimmed
      track.querySelectorAll('[data-mm-card]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-index'), 10);
        var isActive = idx === index;
        var isPeek = idx === index - 1 || idx === index + 1;
        el.classList.toggle('is-active', isActive);
        el.classList.toggle('is-peek', isPeek && !isActive);
      });
    }

    // STEFANO - caption: link alla PDP del prodotto centrale
    var caption = root.querySelector('[data-mm-caption-for="' + type + '"]');
    if (caption) {
      caption.textContent = product.title;
      caption.setAttribute('href', product.url);
    }

    // STEFANO - pannello dettagli
    var titleEl = root.querySelector('[data-mm-title-for="' + type + '"]');
    var priceEl = root.querySelector('[data-mm-price-for="' + type + '"]');
    if (titleEl) {
      titleEl.textContent = product.title;
      titleEl.setAttribute('href', product.url);
    }
    if (priceEl) priceEl.textContent = formatPrice(product.price, state.i18n && state.i18n.locale);

    // STEFANO - prezzo di confronto (barrato): mostrato solo se compareAtPrice > price
    var comparePriceEl = root.querySelector('[data-mm-price-compare-for="' + type + '"]');
    if (comparePriceEl) {
      if (product.compareAtPrice && product.compareAtPrice > product.price) {
        comparePriceEl.textContent = formatPrice(product.compareAtPrice, state.i18n && state.i18n.locale);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.style.display = 'none';
      }
    }

    renderSizes(root, type, state);
    updateFooter(root, state);
    updateNavState(root, type, list, index);
  }

  // STEFANO - disabilita le frecce se siamo al primo o ultimo prodotto
  function updateNavState(root, type, list, index) {
    var slot = root.querySelector('[data-mm-slot="' + type + '"]');
    if (!slot) return;
    var prev = slot.querySelector('[data-mm-nav="prev"]');
    var next = slot.querySelector('[data-mm-nav="next"]');
    if (prev) prev.classList.toggle('is-disabled', index <= 0);
    if (next) next.classList.toggle('is-disabled', index >= list.length - 1);
  }

  function renderSizes(root, type, state) {
    var holder = root.querySelector('[data-mm-sizes-for="' + type + '"]');
    if (!holder) return;
    var product = state[type].product;
    if (!product) { holder.innerHTML = ''; return; }

    var sizeIdx = detectSizeOptionIndex(product);
    var html = product.variants.map(function (v) {
      var size = getSizeValue(v, sizeIdx);
      var cls = 'mm-size' + (v.available ? '' : ' is-disabled');
      return (
        '<button type="button" class="' + cls + '" ' +
          'data-mm-size data-variant-id="' + v.id + '" ' +
          (v.available ? '' : 'disabled aria-disabled="true" ') +
          'role="radio" aria-checked="false">' +
          escText(size) +
        '</button>'
      );
    }).join('');
    holder.innerHTML = html;

    holder.querySelectorAll('[data-mm-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        state[type].variantId = vid;
        holder.querySelectorAll('[data-mm-size]').forEach(function (el) {
          var on = el === btn;
          el.classList.toggle('is-selected', on);
          el.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        updateFooter(root, state);
      });
    });
  }

  // ----- navigazione frecce + click peek + swipe ---------------

  function bindNav(root, type, state, list) {
    var slot = root.querySelector('[data-mm-slot="' + type + '"]');
    if (!slot) return;
    slot.querySelectorAll('[data-mm-nav]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dir = btn.getAttribute('data-mm-nav') === 'next' ? 1 : -1;
        var next = state[type].currentIndex + dir;
        // STEFANO - niente loop: stop a inizio/fine
        if (next < 0 || next >= list.length) return;
        setSelected(root, type, state, list, next);
      });
    });
  }

  function bindCardClick(root, type, state, list) {
    var track = root.querySelector('[data-mm-track="' + type + '"]');
    if (!track) return;

    // STEFANO - flag che indica se l'ultimo touch è stato uno swipe.
    // Se è swipe, sopprimo il click sintetico che il browser genera dopo touchend.
    var swipeJustHappened = false;

    track.addEventListener('mm-swipe-end', function () {
      swipeJustHappened = true;
      setTimeout(function () { swipeJustHappened = false; }, 350);
    });

    track.addEventListener('click', function (e) {
      // STEFANO - se c'è appena stato uno swipe, blocco il click fantasma
      if (swipeJustHappened) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var card = e.target.closest('[data-mm-card]');
      if (!card) return;
      var idx = parseInt(card.getAttribute('data-index'), 10);
      if (isNaN(idx)) return;
      // STEFANO - click su card NON centrale: cambia selezione, blocca link
      // click sulla centrale: lascia passare il link verso la PDP
      if (idx !== state[type].currentIndex) {
        e.preventDefault();
        setSelected(root, type, state, list, idx);
      }
    });
  }

  function bindSwipe(root, type, state, list) {
    var track = root.querySelector('[data-mm-track="' + type + '"]');
    var stage = root.querySelector('[data-mm-stage="' + type + '"]');
    if (!track || !stage) return;

    var startX = 0, startY = 0;
    var dragging = false;
    var locked = false; // axis lock: true se abbiamo deciso che è un drag orizzontale
    var stageWidth = 0;
    var dragOffsetPx = 0;

    function getCardWPx() {
      // STEFANO - leggo la CSS var --mm-card-w (es "65%") e la converto in pixel rispetto allo stage
      var cs = getComputedStyle(stage);
      var raw = cs.getPropertyValue('--mm-card-w') || '65%';
      raw = raw.trim();
      if (raw.endsWith('%')) {
        return stageWidth * (parseFloat(raw) / 100);
      }
      return parseFloat(raw) || stageWidth * 0.65;
    }

    function onStart(clientX, clientY) {
      startX = clientX;
      startY = clientY;
      dragging = true;
      locked = false;
      dragOffsetPx = 0;
      stageWidth = stage.offsetWidth || 1;
      // STEFANO - durante il drag tolgo la transition per follow realtime del dito
      track.style.transition = 'none';
    }

    function onMove(clientX, clientY, ev) {
      if (!dragging) return;
      var dx = clientX - startX;
      var dy = clientY - startY;

      // axis lock: la prima volta che c'è un movimento >8px decido se è swipe orizzontale o scroll verticale
      if (!locked) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          // scroll verticale: abbandono il drag, lascio scrollare la pagina
          dragging = false;
          track.style.transition = '';
          return;
        }
        locked = true;
      }

      // STEFANO - blocca lo scroll verticale della pagina mentre stai swipando il carosello
      if (ev && ev.cancelable) ev.preventDefault();

      // resistenza ai bordi: se sei al primo o ultimo, drag possibile ma con effetto rubber band (50%)
      var idx = state[type].currentIndex;
      var atFirst = idx === 0;
      var atLast = idx === list.length - 1;
      if ((atFirst && dx > 0) || (atLast && dx < 0)) {
        dx = dx * 0.35;
      }

      dragOffsetPx = dx;
      // STEFANO - applico l'offset sopra la posizione di base (calcolata in CSS)
      // setto una CSS var separata per il drag
      track.style.setProperty('--mm-drag-offset', dx + 'px');
    }

    function onEnd() {
      if (!dragging) return;
      var wasLocked = locked;
      dragging = false;
      track.style.transition = ''; // ripristina transizione CSS

      if (!wasLocked) {
        // non c'è stato drag effettivo, niente da fare
        track.style.removeProperty('--mm-drag-offset');
        return;
      }

      // STEFANO - dispatch evento per dire al click handler "ho appena swipato,
      // ignora il click fantasma che sta per arrivare"
      track.dispatchEvent(new CustomEvent('mm-swipe-end'));

      // soglia: se hai trascinato per più del 25% della larghezza card, cambia prodotto
      var threshold = getCardWPx() * 0.25;
      var dir = 0;
      if (dragOffsetPx <= -threshold) dir = 1;
      else if (dragOffsetPx >= threshold) dir = -1;

      // resetto il drag offset (la transizione CSS lo riporterà a 0 fluidamente)
      track.style.removeProperty('--mm-drag-offset');

      if (dir !== 0) {
        var next = state[type].currentIndex + dir;
        if (next >= 0 && next < list.length) {
          setSelected(root, type, state, list, next);
        }
      }
    }

    // touch
    track.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      onStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches.length) return;
      onMove(e.touches[0].clientX, e.touches[0].clientY, e);
    }, { passive: false });

    track.addEventListener('touchend', onEnd);
    track.addEventListener('touchcancel', onEnd);
  }

  // ----- footer totale + CTA -----------------------------------

  function updateFooter(root, state) {
    var totalEl = root.querySelector('[data-mm-total]');
    var totalCompareEl = root.querySelector('[data-mm-total-compare]');
    var ctaEl = root.querySelector('[data-mm-cta]');
    var ctaLabel = root.querySelector('[data-mm-cta-label]');
    var i18n = state.i18n || {};

    var bothProducts = state.top.product && state.slip.product;
    var bothSizes = state.top.variantId && state.slip.variantId;

    if (totalEl) {
      if (bothProducts) {
        totalEl.textContent = formatPrice(state.top.product.price + state.slip.product.price, i18n.locale);
      } else {
        totalEl.textContent = '—';
      }
    }

    // STEFANO - totale barrato: somma dei compareAtPrice (o price se assente/non superiore),
    // mostrato solo se il totale "pieno" supera il totale scontato
    if (totalCompareEl) {
      if (bothProducts) {
        var topRef = (state.top.product.compareAtPrice && state.top.product.compareAtPrice > state.top.product.price)
          ? state.top.product.compareAtPrice : state.top.product.price;
        var slipRef = (state.slip.product.compareAtPrice && state.slip.product.compareAtPrice > state.slip.product.price)
          ? state.slip.product.compareAtPrice : state.slip.product.price;
        var totalRef = topRef + slipRef;
        var totalReal = state.top.product.price + state.slip.product.price;
        if (totalRef > totalReal) {
          totalCompareEl.textContent = formatPrice(totalRef, i18n.locale);
          totalCompareEl.style.display = 'inline';
        } else {
          totalCompareEl.textContent = '';
          totalCompareEl.style.display = 'none';
        }
      } else {
        totalCompareEl.textContent = '';
        totalCompareEl.style.display = 'none';
      }
    }

    if (ctaEl) ctaEl.disabled = !bothSizes;
    if (ctaLabel) {
      ctaLabel.textContent = bothSizes
        ? (i18n.ctaSetAdd || 'Aggiungi set al carrello')
        : (i18n.ctaSelect || 'Seleziona le taglie');
    }

    // STEFANO - stato dei singoli ATC: abilitati solo se la rispettiva taglia è selezionata
    ['top', 'slip'].forEach(function (type) {
      var btn = root.querySelector('[data-mm-cta-single="' + type + '"]');
      if (!btn) return;
      var hasSize = !!state[type].variantId;
      btn.disabled = !hasSize;
    });
  }

  // ----- ATC con integrazione Prestige -------------------------

  // STEFANO - logica ATC condivisa: accetta array items e bottone target.
  // Non gestisce le properties: chi chiama decide se passarle o meno.
  function performAddToCart(items, ctaEl, feedback, state, successMsg) {
    if (!items || !items.length) return;
    if (ctaEl) {
      ctaEl.disabled = true;
      ctaEl.classList.add('is-loading');
      ctaEl.setAttribute('aria-busy', 'true');
    }
    clearFeedback(state, feedback);

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    var payload = {
      items: items,
      sections: sectionsToBundle.join(',')
    };

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (responseJson) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cartContent) {
          cartContent.sections = responseJson.sections || {};
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartContent }
          }));
        });
      })
      .then(function () {
        showFeedbackSuccess(state, feedback, successMsg);
      })
      .catch(function (err) {
        console.warn('[mm] add to cart error', err);
        var fallback = (state.i18n && state.i18n.msgError) || 'Errore aggiunta al carrello.';
        var msg = (err && err.description) || (err && err.message) || fallback;
        showFeedbackError(feedback, msg);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        if (ctaEl) {
          ctaEl.classList.remove('is-loading');
          ctaEl.removeAttribute('aria-busy');
          ctaEl.disabled = false;
        }
      });
  }

  // STEFANO - ATC SET: aggiunge entrambi top + slip con properties _bundle
  function bindCta(root, state) {
    var ctaEl = root.querySelector('[data-mm-cta]');
    if (!ctaEl) return;
    var feedback = root.querySelector('[data-mm-feedback]');

    ctaEl.addEventListener('click', function () {
      if (!state.top.variantId || !state.slip.variantId) return;
      var items = [
        { id: state.top.variantId, quantity: 1, properties: { '_bundle': 'mix-match' } },
        { id: state.slip.variantId, quantity: 1, properties: { '_bundle': 'mix-match' } }
      ];
      var msg = (state.i18n && state.i18n.msgSetAdded) || 'Set aggiunto al carrello.';
      performAddToCart(items, ctaEl, feedback, state, msg);
    });
  }

  // STEFANO - ATC SINGOLO: aggiunge solo top o solo slip, senza properties speciali
  function bindCtaSingle(root, state, type) {
    var ctaEl = root.querySelector('[data-mm-cta-single="' + type + '"]');
    if (!ctaEl) return;
    var feedback = root.querySelector('[data-mm-feedback]');

    ctaEl.addEventListener('click', function () {
      var variantId = state[type].variantId;
      if (!variantId) return;
      var items = [{ id: variantId, quantity: 1 }];
      var i18n = state.i18n || {};
      var msg = type === 'top'
        ? (i18n.msgTopAdded || 'Top aggiunto al carrello.')
        : (i18n.msgSlipAdded || 'Slip aggiunto al carrello.');
      performAddToCart(items, ctaEl, feedback, state, msg);
    });
  }

  // ----- feedback ----------------------------------------------

  var CHECK_SVG = '<svg class="mm-feedback__check" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">' +
    '<circle cx="8" cy="8" r="8" fill="#2e7d32"/>' +
    '<path d="M4.5 8.2 L7 10.7 L11.7 6" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function clearFeedback(state, feedback) {
    if (state.feedbackTimer) {
      clearTimeout(state.feedbackTimer);
      state.feedbackTimer = null;
    }
    if (feedback) {
      feedback.classList.remove('is-success', 'is-error', 'is-fading');
      feedback.innerHTML = '';
    }
  }

  function showFeedbackSuccess(state, feedback, message) {
    if (!feedback) return;
    clearFeedback(state, feedback);
    feedback.classList.add('is-success');
    feedback.innerHTML = CHECK_SVG + '<span class="mm-feedback__text">' + escText(message) + '</span>';
    state.feedbackTimer = setTimeout(function () {
      feedback.classList.add('is-fading');
      state.feedbackTimer = setTimeout(function () {
        clearFeedback(state, feedback);
      }, 400);
    }, 10000);
  }

  function showFeedbackError(feedback, message) {
    if (!feedback) return;
    feedback.classList.remove('is-success', 'is-fading');
    feedback.classList.add('is-error');
    feedback.innerHTML = '<span class="mm-feedback__text">' + escText(message) + '</span>';
  }

  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escText(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
})();
